import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'sort',
  standalone: false,
})
export class SortPipe implements PipeTransform {
  /**
   * This custom pipe will sort an array by given properties
   * @param value
   * @param property
   * @param ascending
   * @returns Sorted array based on the ascending flag
   */
  transform(value: any[], property: string, ascending: boolean = true): any[] {
    if (!value || value.length <= 1 || !property) {
      return value
    }

    return value.sort((a, b) => {
      if (a[property] < b[property]) {
        return ascending ? -1 : 1
      } else if (a[property] > b[property]) {
        return ascending ? 1 : -1
      } else {
        return 0
      }
    })
  }
}
